
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n  <header>\n    <h1 id=\"fxa-400-header\">{{#t}}Bad Request{{/t}}</h1>\n  </header>\n\n  <section>\n    <div class=\"error visible\">{{message}}</div>\n  </section>\n</div>\n\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/400.mustache
// module id = 152
// module chunks = app